import Analytics from '@withlocals/withlocals-analytics';
import LocalizedLinkButton from 'components/RoundedButton/LocalizedLinkButton';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const CSS = require('./Notfound.module.scss');

function NotFoundComponent() {
  useEffect(() => {
    Analytics.track('404', window.location.href, window.document.referrer);
    console.error(
      `404 rendered (pathname: ${window.location.pathname}, search: ${window.location.search}, referrer: ${window.document.referrer}, href: ${window.location.href})`,
    );
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={CSS.NotFoundContainer}>
      <Helmet>
        <meta name="render:status_code" content="404" />
      </Helmet>
      <div className={CSS.NotFoundHeader}>
        <h1 className={CSS.NotFoundTitle}>404 Page not found</h1>
      </div>
      <div className={CSS.NotFoundSubtitleContainer}>
        <LocalizedLinkButton to={'/'} className={CSS.NotFoundSubtitle} inverted>
          Find your destination
        </LocalizedLinkButton>
      </div>
    </div>
  );
}

export { NotFoundComponent };

export default () => {
  return (
    <NavigationableLayout
      component={NotFoundComponent}
      showSearchInNavbar
      transparentNavbar
    />
  );
};
